<script setup>
import Swal from 'sweetalert2';
import { onMounted, reactive } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { VForm } from 'vuetify/components/VForm';

const route = useRoute();
const router = useRouter();

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: toast => {
    toast.onmouseenter = Swal.stopTimer
    toast.onmouseleave = Swal.resumeTimer
  },
})

definePage({
  meta: {
    layout: 'blank',
    public: true,
  },
})

const gender = [
  'Male',
  'Female',
]

const state = reactive({
  identity: {
    name: '',
    gender: ref('Male'),
  },
  session_url:'',
})


const name = ref('')

// const radioGroup = ref(1)
const refForm = ref()

function generateRandomString() {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const firstCharacter = characters.charAt(Math.floor(Math.random() * characters.length));
  const randomNumber = Math.floor(1000 + Math.random() * 9000); // Generates a random number between 1000 and 9999
  return firstCharacter + randomNumber;
}

const updateIdentity = async () => {
  try {
    const res = await $api('update-identity/'+route.params.id, {
      method: 'POST',
      body: state.identity,
      onResponseError({ response }) {
        console.log(response._data.errors);
      },
    })
    console.log(res)
    window.location.href = `${res}`;
  } catch (error) {
    console.error('Request failed:', error)
  }
}
const getSession = async () => {
  try {
    console.log('route.params', route.query.s)
    var session_url =  route.query.s ? route.query.s : '';
    const res = await $api('bot-allocated-text/'+session_url+'/'+route.params.id, {
      method: 'GET',
      onResponseError({ response }) {
        console.log('response', response)
        const errors = response._data.message ? response._data.message : response._data.error
        Toast.fire({
          icon: "error",
          title: errors,
        })
      },
    })
    console.log(res)
    state.identity = res
    if (res.bots.length > 0) {
      state.identity.name = res.bots[0].name; 
      state.identity.gender = res.bots[0].gender
    } else {
      state.identity.name = generateRandomString();
      if (res.gender == 'neutral') {
        state.identity.gender = 'Male';
      }
    }

  } catch (error) {
    console.error('Request failed:', error)
  }
}
const getBaseUrl = async () => {
  try {
    const res = await $api('baseurl', {
      method: 'GET',
      onResponseError({ response }) {
        console.log(response._data.errors);
      },
    })
    state.baseURL = res;
  } catch (error) {
    console.error('Request failed:', error)
  }
}

onMounted(() => {
  getBaseUrl()
  getSession()
});
</script>

<template>
  <VContainer>
    <VForm ref="refForm" @submit.prevent="updateIdentity">
      <VCard class="mb-6">
        <VCardText>
          <VRow>
            <VCol
              cols="12"
              md="6"
            >
              <AppTextField
                v-model="state.identity.name"
                label="Name"
                placeholder="Your Name"
              />
            </VCol>
            <VCol
              cols="12"
              md="6"
            >
              <div class="fo-gender">
                <label class="fo-label">Gender</label>
                <VRadioGroup
                  v-model="state.identity.gender"
                  inline
                >
                  <div>
                    <!-- <VRadio
                      v-for="getGender in gender"
                      :key="getGender"
                      :label="getGender"
                      :value="getGender.toLocaleLowerCase()"
                    /> -->
                    <VRadio
                      v-for="getGender in gender"
                      :key="getGender"
                      :label="getGender"
                      :value="getGender"
                      v-model="state.identity.gender"
                    />
                  </div>
                </VRadioGroup>
              </div>
            </VCol>
            <VCol cols="12">
              <VBtn type="submit">
                SAVE AND RETURN
              </VBtn>
            </VCol>
          </VRow>
        </VCardText>
      </VCard>
    </VForm>
  </VContainer>
</template>
